<template>
  <div>
    <bubble-chart style="position: relative" :height="height" :data="this.bubblesChartData"
                  :options="this.bubblesChartOptions"
                  v-if="this.bubblesChartData"></bubble-chart>
    <v-btn color="success text--darken-2" right dark x-small @click="showFullListClick" :disabled="btnDisabled">
      Show full list
    </v-btn>
    <show-list ref="jobOffersPerLocationBubbleList" :title="'job offers per location'" :list="fullList" :headers="['source', '#job offers']"></show-list>

  </div>

</template>

<script>
  import BubbleChart from "../Wrappers/bubbleChart";
  import {jobOffersColors} from "../../../constants/constants";
  import ShowList from "../../Dialogs/Profiles/showList";

  export default {
    name: "jobOffersPerLocationBubbles",
    components: {ShowList, BubbleChart},
    props: ['jobOffers', 'height'],
    data(){
      return {
        datasets: undefined,
        fullList: [],
        bubblesChartData: {},
        bubblesChartOptions: {
          responsive: true,
          maintainAspectRatio: false,
          animation:{
            // onComplete: this.drawValues
          },
          legend: {
            display:true
          },
          tooltips:{
            enabled: true,
            callbacks: {
              label: this.tooltipLabel
            }
          },
          scales: {
            xAxes: [{
              display:false,
              ticks: {
                beginAtZero: false,
                // min: this.getMinX(),
                // max: this.getMaxX(),
              }
            }],
            yAxes: [{
              display:false,
              ticks: {
              }
            }]
          },
        },
      }
    },
    watch: {
      jobOffers: function (newVal, oldVal) {
        if (newVal.length) {
          this.buildChart();
        }
      }
    },
    methods: {
      composeBubblesChartData() {
        // if (this.datasets) {
        //   return {datasets: this.datasets};
        // }

        this.fullList= [];
        let datasets = [];

        let availableLocations = this.jobOffers.filter(e => e.location !== undefined)
        let locations = availableLocations.map(e => e.location.locality).filter((value, index, self) => self.indexOf(value) === index);

        locations.forEach((location, i) => {

          let l = availableLocations.filter(e => e.location.locality === location);

          if (location !== undefined){
            let dataPoint = {
              x: Math.round(l[0].location.geoCodePoints.coordinates[1] * 100000) / 100000,
              y: Math.round(l[0].location.geoCodePoints.coordinates[0] * 100000) / 100000,
              r: Math.log(l.length+1)*10,
            };

            this.fullList.push({label: location, data: [l.length + 1]});

            datasets.push({label:[location], data: [dataPoint], backgroundColor: jobOffersColors[i]});
          }
        });

        this.fullList = this.fullList.sort((a,b) => b.data[0] - a.data[0]);
        let topLocations = this.fullList.slice(0,5).map(e => e.label);
        datasets = datasets.filter(e => topLocations.indexOf(e.label[0]) > -1);
        this.datasets = datasets;
        return {datasets};
      },

      drawValues(Chart){
        let ctx = Chart.chart.ctx;

        Chart.chart.config.data.datasets.forEach(function (dataset, i) {
          let label = dataset.label[0];
          let meta = Chart.chart.controller.getDatasetMeta(i);
          meta.data.forEach(function (point, index) {
            let data = dataset.data[index];
            let originalR = Math.round(Math.exp( data.r / 10))-1;
            ctx.fillStyle = '#333';
            ctx.fillText(`${label}: ${originalR}`, point._model.x - 10, point._model.y );
          });
        });

      },
      tooltipLabel(tooltipItem, data){
        let label = data.datasets[tooltipItem.datasetIndex].label || '';
        return label + ': ' + Math.round(Math.exp( data.datasets[tooltipItem.datasetIndex].data[0].r / 10));
      },
      showFullListClick() {
        this.$refs.jobOffersPerLocationBubbleList.openModal();
      },
      buildChart() {
        this.bubblesChartData = this.composeBubblesChartData();

        let minX = Math.min(...this.bubblesChartData.datasets.map(e => e.data[0].x));
        let maxX = Math.max(...this.bubblesChartData.datasets.map(e => e.data[0].x));

        let minY = Math.min(...this.bubblesChartData.datasets.map(e => e.data[0].y));
        let maxY = Math.max(...this.bubblesChartData.datasets.map(e => e.data[0].y));

        this.bubblesChartOptions.scales.xAxes[0].ticks.min = minX - 0.2*(maxX - minX);
        this.bubblesChartOptions.scales.xAxes[0].ticks.max = maxX + 0.2*(maxX - minX);

        this.bubblesChartOptions.scales.yAxes[0].ticks.min = minY - 0.2*(maxY - minY);
        this.bubblesChartOptions.scales.yAxes[0].ticks.max = maxY + 0.2*(maxY - minY);
      }
    },
    computed: {
      btnDisabled(){
        return this.bubblesChartData.datasets ? this.bubblesChartData.datasets.length === 0 : true;
      }
    },
    mounted(){
      this.buildChart();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Charts/Profile/jobOffersPerLocationBubbles.vue